export default class CreateIMUserModel {
  code?: string;

  email?: string;

  gender='U';

  name?: string;

  phonePrefix='86';// 默认是CN

  phoneNo?: string;

  userAccount?: string;

  remark?: string;
}
